import { Link } from "react-router-dom";
import { UserPlus, FileCheck2, BadgeCheck, Users, Ban } from "lucide-react";
import { PageHeader } from "../components/Layout";

const STEPS = [
  [UserPlus, "Opret en konto", "Opret en personlig konto med din arbejdsmail."],
  [FileCheck2, "Anmod om ejerskab", "Find jeres klinik og send en ejerskabsanmodning med CVR og kontaktoplysninger."],
  [BadgeCheck, "Manuel godkendelse", "VetPris kontrollerer anmodningen. Først efter godkendelse kan I redigere klinikken."],
  [Users, "Administrér priser og personale", "Opdatér lokationer og priser, og giv kolleger begrænsede rettigheder."],
];

export default function ForClinics() {
  return (
    <div data-testid="for-clinics-page">
      <PageHeader eyebrow="For dyreklinikker" title="Hold jeres priser korrekte og gennemskuelige">Som verificeret klinikadministrator kan I selv vedligeholde profil, lokationer og priser – og vise dyreejere, at priserne er bekræftet af klinikken.</PageHeader>
      <div className="container-vp py-14">
        <ol className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map(([Icon, t, d], i) => (
            <li key={t} className="card-vp p-6">
              <span className="text-xs font-bold text-[#087F72]">Trin {i + 1}</span>
              <Icon className="h-7 w-7 text-[#087F72] mt-3" aria-hidden="true" />
              <h2 className="font-heading font-bold text-[#153C3A] mt-3">{t}</h2>
              <p className="text-sm text-[#52706D] mt-2">{d}</p>
            </li>
          ))}
        </ol>
        <div className="grid lg:grid-cols-2 gap-6 mt-12">
          <div className="card-vp p-6">
            <h2 className="text-xl font-bold text-[#153C3A]">Sådan markeres priser</h2>
            <ul className="mt-3 space-y-2 text-sm text-[#334155]">
              <li><strong>Fast pris</strong> – prisen gælder som angivet.</li>
              <li><strong>Fra-pris</strong> – laveste pris; endelig pris kan blive højere.</li>
              <li><strong>Estimat</strong> – vejledende prisinterval.</li>
              <li>Hver pris har betingelser, kilde og verificeringsstatus, og alle ændringer gemmes i historikken.</li>
            </ul>
          </div>
          <div className="card-vp p-6">
            <h2 className="text-xl font-bold text-[#153C3A] flex items-center gap-2"><Ban className="h-5 w-5 text-[#F0A94C]" />Ingen betalte placeringer</h2>
            <p className="text-sm text-[#334155] mt-3">VetPris sælger ikke bedre placeringer i søgeresultaterne. Resultater sorteres udelukkende efter pris eller afstand. Automatisk prisindsamling fra hjemmesider er ikke aktiveret og vil kun ske med dokumenteret tilladelse.</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 mt-10">
          <Link to="/klinik/overtag" className="btn-primary" data-testid="for-clinics-claim-button">Overtag din klinikprofil</Link>
          <Link to="/klinik/opret" className="btn-outline" data-testid="for-clinics-new-button">Opret ny klinik</Link>
          <Link to="/login?tab=register" className="btn-outline" data-testid="for-clinics-register-button">Opret klinikkonto</Link>
          <Link to="/kontakt" className="btn-outline" data-testid="for-clinics-contact-button">Kontakt VetPris</Link>
        </div>
      </div>
    </div>
  );
}
